/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/communications/', params);
}

function get(id, params) {
  return api.get(`/communications/${id}`, params);
}

function create(params) {
  return api.post('/communications', params);
}

function update(id, params) {
  return api.put(`/communications/${id}/update`, params);
}

function send(id, params) {
  return api.post(`/communications/${id}/send`, params);
}

function remove(id, params) {
  return api.delete(`/communications/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function sendEmail(params) {
  return api.post('/communications/email-send', params);
}

export const communicationsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  send,
  sendEmail,
};
